/**
 * WHICH OF THE SHELL'S FUNCTIONS ARE EVENT HANDLERS (plan shell-contexts, A2): called from a click, a key, a
 * listener or an effect - never while a component draws. Those keep their identity across renders
 * (`useStableHandlersOf`, DeathWatchSimulator), so a context holding them changes only when its data does.
 *
 * The convention this rests on: in the shell, `handleX`, `onX` and `doX` are event handlers, and a function read
 * while drawing is named for what it answers (`isLocked`, `nameOf`, `sheetFor`). A function read while drawing must
 * never match: wrapped, it would answer from the last commit, and its readers would not re-render when it changes.
 */

/** The shell's event verbs that the prefix rule does not name. */
const NAMED = new Set(['updateTab', 'resetActionEconomy', 'acceptRemainingHits']);

/** Is this shell function an event handler, safe to keep stable? */
export const isShellHandler = (name) => /^(handle|on|do)[A-Z]/.test(name) || NAMED.has(name);
